import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Layout, Menu, Breadcrumb, Icon, Card } from 'antd';
import '../../assets/css/App.css';
import routes from '../../model/router';
import Header1 from '../public';
import BicombImg from "../../assets/images/clarityICI.jpg";

// ===============================
// 1) CLARITY-ICI Matrix (All) data object (from attached image)
//    - Preserves coordinates: rowIndex, colIndex
//    - Preserves values as shown (Months)
// ===============================
const CLARITY_ICI_ALL = {
  title: " ",
  xAxisLabel: "Step 2: Median survival outcomes",
  yAxisLabel: "Step 1: Identify your interested variables and the target events",
  xLabels: [
    "Smoking No",
    "Smoking Yes",
    "ECOG ≥1",
    "ECOG <1",
    "TMB Low",
    "Stage IV",
    "Patho LUSC",
    "Patho Other",
    "TMB High",
    "Patho LUAD",
    "Stage I~III",
  ],
  rows: [
    { yLabel: "Age >65 OS", values: [null, null, 8.9, 15.6, null, 14.4, 12.7, 13.3, null, 16.4, 21.2] },
    { yLabel: "Age >65 PFS", values: [null, null, 3.1, 5.1, null, null, null, null, null, null, null] },

    { yLabel: "Age ≤65 OS", values: [null, null, 10.6, 15.2, 12.8, 13.9, null, null, null, 14.2, 17.2] },
    { yLabel: "Age ≤65 PFS", values: [2.6, 4.4, 2.8, 4.2, 2.7, null, null, null, null, 5.3, null] },

    { yLabel: "ECOG ≥1 OS", values: [null, null, null, null, null, 10.7, null, null, null, null, 17.6] },

    { yLabel: "IO_Type Mono OS", values: [null, null, 9.0, 15.6, null, 13.0, null, null, null, null, 19.8] },
    { yLabel: "IO_Type Mono PFS", values: [null, null, 2.8, 4.1, null, null, null, null, null, null, null] },

    { yLabel: "Line 1L OS", values: [null, null, 13.3, 15.8, null, 13.9, null, null, null, null, 20.0] },
    { yLabel: "Line 1L PFS", values: [null, null, 6.2, 11.5, null, null, null, null, null, null, null] },

    { yLabel: "Line ≥2L OS", values: [null, null, 8.4, 15.4, null, 13.9, null, null, null, null, 16.5] },
    { yLabel: "Line ≥2L PFS", values: [null, null, 2.5, 3.8, null, null, null, null, null, null, null] },

    { yLabel: "P_Treat No OS", values: [null, null, 13.3, 15.8, null, 13.9, null, null, null, null, 20.0] },
    { yLabel: "P_Treat No PFS", values: [null, null, 6.2, 11.5, null, null, null, null, null, null, null] },

    { yLabel: "P_Treat Yes OS", values: [null, null, 8.4, 15.6, null, 13.9, null, null, null, null, 16.5] },
    { yLabel: "P_Treat Yes PFS", values: [null, null, 2.5, 3.8, null, null, null, null, null, null, null] },

    { yLabel: "Patho LUAD OS", values: [null, null, 10.1, 14.3, 16.5, 16.5, null, null, 18.0, null, 21.9] },
    { yLabel: "Patho LUAD PFS", values: [null, null, 3.2, 5.2, null, null, null, null, null, null, null] },

    { yLabel: "Patho LUSC OS", values: [null, null, 8.4, 19.0, null, null, null, null, null, null, null] },
    { yLabel: "Patho Other OS", values: [null, null, 10.8, 15.6, null, null, 11.4, null, null, null, 18.0] },

    { yLabel: "Real_World Yes OS", values: [null, null, 9.4, 14.7, 12.9, 13.3, 12.3, 11.0, 15.3, 15.2, 20.6] },
    { yLabel: "Real_World Yes PFS", values: [null, null, 3.2, 5.3, null, null, null, null, null, null, null] },

    { yLabel: "Region NAM OS", values: [null, null, 9.0, 16.4, 14.0, 14.1, null, null, 15.5, null, 20.6] },
    { yLabel: "Region NAM PFS", values: [null, null, 2.7, 4.3, null, null, null, null, null, null, null] },

    { yLabel: "Sex Female OS", values: [null, null, 11.0, 17.0, null, 14.9, null, null, null, null, 22.0] },
    { yLabel: "Sex Female PFS", values: [null, null, 3.3, 4.0, null, null, null, null, null, null, null] },

    { yLabel: "Sex Male OS", values: [null, null, 10.2, 15.5, null, 13.6, 12.8, 11.1, null, 15.3, 18.4] },
    { yLabel: "Sex Male PFS", values: [null, null, 3.1, 6.0, null, 4.2, null, null, null, null, 6.1] },

    { yLabel: "Smoking No OS", values: [null, null, 13.0, 14.0, null, 16.2, null, null, null, null, 20.6] },
    { yLabel: "Smoking Yes OS", values: [null, null, 9.7, 15.9, null, 14.5, null, null, null, null, 20.4] },
    { yLabel: "Smoking Yes PFS", values: [null, null, 3.5, 6.1, null, null, null, null, null, null, null] },

    { yLabel: "Stage IV OS", values: [null, null, 10.7, 14.8, null, null, null, null, null, null, null] },
    { yLabel: "Stage IV PFS", values: [null, null, 3.2, 6.4, null, null, null, null, null, null, null] },

    { yLabel: "Stage I~III OS", values: [null, null, null, null, null, null, 15.8, 18.0, null, null, 21.9] },

    { yLabel: "TMB High OS", values: [null, null, 11.9, 18.7, null, 15.0, 11.7, 13.7, null, 18.0, 20.7] },
    { yLabel: "TMB Low OS", values: [null, null, 8.1, 15.6, null, 13.8, null, null, null, null, 21.2] },
    { yLabel: "TMB Low PFS", values: [null, null, 2.4, 3.6, null, 2.7, null, null, null, null, 9.3] },

    { yLabel: "Tumor_Purity <50 OS", values: [null, null, null, null, null, 16.5, null, null, null, 16.9, null] },
    { yLabel: "Tumor_Purity ≥50 OS", values: [null, null, null, null, null, 15.1, 14.7, null, null, 15.5, 20.4] },
  ],
  valueMin: 2.4,
  valueMax: 22.0,
};

// ===============================
// 2) Color scale helper (blue -> white -> green)
// ===============================
const lerp = (a, b, t) => a + (b - a) * t;

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return {
    r: parseInt(h.substring(0, 2), 16),
    g: parseInt(h.substring(2, 4), 16),
    b: parseInt(h.substring(4, 6), 16),
  };
}
function rgbToHex({ r, g, b }) {
  const toHex = (x) => x.toString(16).padStart(2, "0");
  return `#${toHex(Math.round(r))}${toHex(Math.round(g))}${toHex(Math.round(b))}`;
}
function interpolateHex(c1, c2, t) {
  const a = hexToRgb(c1);
  const b = hexToRgb(c2);
  return rgbToHex({
    r: lerp(a.r, b.r, t),
    g: lerp(a.g, b.g, t),
    b: lerp(a.b, b.b, t),
  });
}
function valueToColor(v, vMin, vMax) {
  if (v === null || v === undefined) return "transparent";
  const t = Math.min(1, Math.max(0, (v - vMin) / (vMax - vMin)));
  const blue = "#08306b";
  const white = "#f7f7f7";
  const green = "#2ca25f";
  if (t <= 0.5) return interpolateHex(blue, white, t / 0.5);
  return interpolateHex(white, green, (t - 0.5) / 0.5);
}

// ===============================
// 3) Tooltip sentence builder
//    A = x-axis label text
//    B = y-axis label text
//    C = OS or PFS from y-axis label suffix
//    D = cell value (months)
// ===============================
function parseOutcomeFromY(yLabel) {
  const s = (yLabel || "").trim();
  if (s.endsWith(" OS")) return "OS";
  if (s.endsWith(" PFS")) return "PFS";
  // fallback: try to find " OS"/" PFS" anywhere near the end
  const m = s.match(/\b(OS|PFS)\b\s*$/);
  return m ? m[1] : "";
}
function removeOutcomeSuffix(yLabel) {
  return (yLabel || "").replace(/\s+(OS|PFS)\s*$/i, "").trim();
}
function buildHoverSentence({ xLabel, yLabel, value }) {
  const B = (xLabel || "").trim();
  const A = removeOutcomeSuffix(yLabel);
  const C = parseOutcomeFromY(yLabel);
  const D = value;
  return `Patient with the stage 1 variable of ${A} (level) and the stage 2 variable of ${B} (level), the corresponding median ${C} stratification is ${D} months.`;
}

// ===============================
// 4) Matrix renderer (left-aligned + smaller x-labels + cursor tooltip)
// ===============================
class ClarityMatrixGrid extends React.PureComponent {
  render() {
    const { data, hover, tooltip, onEnter, onMove, onLeave } = this.props;
    const { xLabels, rows, valueMin, valueMax, xAxisLabel, yAxisLabel } = data;

    // Layout constants
    const cellW = 55;
    const cellH = 30;
    const yLabelW = 220;

    const isHover = (ri, ci) => hover && hover.r === ri && hover.c === ci;

    const axisLabelStyle = (active) => ({
      fontWeight: active ? "bold" : "normal",
      color: active ? "#111" : "#666",
      opacity: active ? 1 : 0.85,
      transition: "all 120ms ease",
      userSelect: "none",
    });

    return (
      <div style={{ position: "relative", marginTop: 10 }}>
        {/* Tooltip near cursor */}
        {tooltip && tooltip.visible ? (
          <div
            style={{
              position: "fixed",
              left: tooltip.x + 12,
              top: tooltip.y + 12,
              maxWidth: 420,
              background: "rgba(17,17,17,0.92)",
              color: "#fff",
              padding: "8px 10px",
              borderRadius: 6,
              fontSize: 12,
              lineHeight: "16px",
              zIndex: 9999,
              pointerEvents: "none",
              boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
            }}
          >
            {tooltip.text}
          </div>
        ) : null}

        {/* Axis titles row (yAxisLabel aligned to the left edge of the color blocks) */}
        <div
  style={{
    display: "grid",
    gridTemplateColumns: `${yLabelW}px repeat(${xLabels.length}, ${cellW}px)`,
    alignItems: "end",
    marginBottom: 0,
    columnGap: 2, // ✅ 与色块网格 gap 保持一致
  }}
>
          {/* y-axis label: italic, right-aligned to the boundary where color blocks start */}
          <div
            style={{
              fontSize: 12,
              color: "#666",
              fontWeight: "bold",
              fontStyle: "italic",
              textAlign: "right",
              lineHeight: "14px",
              width: "100%",
              display: "flex",
              justifyContent: "flex-end", // 关键：右端严格贴齐色块左边界（yLabelW的右边界）
              paddingRight: 0,
              marginRight: 0,
              userSelect: "none",
            }}
          >
           {/* yAxisLabel */}
          </div>

          {/* x-axis label centered over the color-block area */}
          <div
            style={{
              gridColumn: `span ${xLabels.length}`,
              textAlign: "center",
              fontSize: 12,
              color: "#666",
              fontWeight: "bold",
              userSelect: "none",
            }}
          >
           {/* xAxisLabel */}
          </div>
        </div>

        {/* X-axis labels (smaller font) */}
        <div
  style={{
    display: "grid",
    gridTemplateColumns: `${yLabelW}px repeat(${xLabels.length}, ${cellW}px)`,
    alignItems: "end",
    marginBottom: 6,
    columnGap: 2, // ✅ 与色块网格 gap 保持一致（否则会累计错位）
  }}
>
  <div></div>

  {xLabels.map((xl, ci) => {
    const active = hover && hover.c === ci;

    return (
      <div
        key={`${xl}-${ci}`}
        style={{
          ...axisLabelStyle(active),
          width: cellW,
          height: 34,
          position: "relative",
          display: "flex",
          justifyContent: "flex-start", // ✅ 让锚点从列左侧开始
          alignItems: "flex-end",
          overflow: "visible",
        }}
      >
        {/* 可选：画一个“刻度线”，明确标记每列左边界（你要的 tick 对齐） */}
        <div
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            width: 1,
            height: 6,
            background: "#fff",
            opacity: 0.6,
          }}
        />

        {/* 标签本体：以“左下角”为旋转原点，旋转后仍对齐列左边界 */}
        <div
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            transform: "rotate(-35deg)",
            transformOrigin: "left bottom", // ✅ 核心：严格对齐到色块左侧
            fontSize: 11,
            lineHeight: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {xl}
        </div>
      </div>
    );
  })}
</div>

        {/* Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `${yLabelW}px repeat(${xLabels.length}, ${cellW}px)`,
            gridAutoRows: `${cellH}px`,
            gap: 2,
          }}
        >
          {rows.map((row, ri) => {
            const rowActive = hover && hover.r === ri;

            return (
              <React.Fragment key={row.yLabel}>
                {/* Y label */}
                <div
                  style={{
                    ...axisLabelStyle(rowActive),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    paddingRight: 10,
                    fontSize: 13,
                  }}
                >
                  {row.yLabel}
                </div>

                {/* Cells */}
                {row.values.map((v, ci) => {
                  const active = isHover(ri, ci);
                  const bg = valueToColor(v, valueMin, valueMax);
                  const isEmpty = v === null || v === undefined;

                  return (
                    <div
                      key={`${ri}-${ci}`}
                      onMouseEnter={(e) => {
                        if (isEmpty) return;
                        onEnter(e, ri, ci, {
                          xLabel: xLabels[ci],
                          yLabel: row.yLabel,
                          value: v,
                        });
                      }}
                      onMouseMove={(e) => {
                        if (isEmpty) return;
                        onMove(e);
                      }}
                      onMouseLeave={onLeave}
                      style={{
                        width: cellW,
                        height: cellH,
                        background: bg,
                        border: active ? "2px solid #111" : "1px solid #e6e6e6",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 13,
                        fontWeight: active ? "bold" : "normal",
                        color: isEmpty ? "transparent" : "#111",
                        cursor: isEmpty ? "default" : "pointer",
                        filter: active ? "brightness(1.08)" : "none",
                        transition: "all 120ms ease",
                        userSelect: "none",
                      }}
                    >
                      {isEmpty ? "" : v}
                    </div>
                  );
                })}
              </React.Fragment>
            );
          })}
        </div>

      </div>
    );
  }
}

const { Header, Content, Footer, Sider } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;

const Ajax = require('axios');

class ClarityICIWestern extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverCell: null, // { r, c }
      tooltip: {
        visible: false,
        x: 0,
        y: 0,
        text: "",
      },
    };
  }

  handleEnterCell = (e, r, c, meta) => {
    const text = buildHoverSentence(meta);
    this.setState({
      hoverCell: { r, c },
      tooltip: {
        visible: true,
        x: e.clientX,
        y: e.clientY,
        text,
      },
    });
  };

  handleMoveCell = (e) => {
    // lightweight cursor-follow
    const { tooltip } = this.state;
    if (!tooltip.visible) return;
    this.setState({
      tooltip: {
        ...tooltip,
        x: e.clientX,
        y: e.clientY,
      },
    });
  };

  handleLeaveCell = () => {
    this.setState({
      hoverCell: null,
      tooltip: {
        visible: false,
        x: 0,
        y: 0,
        text: "",
      },
    });
  };

  render() {
    return (
      <div>
        <Header1></Header1>
        <Content style={{ padding: '0 50px' }}>
          <Layout style={{ background: '#fff' }}>
            <Sider width={200} style={{ background: '#fff' }}>
              <Menu
                mode="inline"
                defaultSelectedKeys={['3']}
                defaultOpenKeys={['sub1']}
                style={{ height: '100%' }}
              >
                <SubMenu key="sub1" title={<span><Icon type="user" />CLARITY-ICI</span>}>
                <Menu.Item key="1"><Link to="/clarityICI">Introduction</Link></Menu.Item>
                <Menu.Item key="2"><Link to="/clarityICIAll">All Population</Link></Menu.Item>
                <Menu.Item key="3"><Link to="/clarityICIWestern">Western</Link></Menu.Item>
                <Menu.Item key="4"><Link to="/clarityICIEastAsian">East Asian</Link></Menu.Item>
                <Menu.Item key="5"><Link to="/clarityICIIntroAnn">Animation</Link></Menu.Item>
                </SubMenu>
              </Menu>
            </Sider>

            <Content style={{ padding: '0 50px' }}>
              <div
                style={{
                  background: `url(${BicombImg}) no-repeat center center`,
                  height: 300,
                  width: "100%",
                  backgroundSize: "cover",
                }}
              >
                <div style={{ textAlign: "center", color: "#fff" }}>
                  <br></br><br></br><br></br>
                  <txt style={{ fontSize: 45, fontWeight: 'bold' }}>
                    Clinical Attribute–Based Risk Matrix for Prognostication in Immunotherapy-Treated NSCLC
                  </txt>
                  <br></br>
                </div>
              </div>

              <div>
                <br></br>
                <br></br>
                <txt style={{ fontSize: 23, fontWeight: 'bold', paddingRight: 100 }}>
                  Western Population CLARITY-ICI Matrix
                </txt>
                <br></br>

                <div style={{ fontSize: 20 }}>
                  <txt>
                    <br></br>
                    
                    {/* (2) Left-aligned with the heading above: remove extra paddingLeft here */}
                    <div style={{ marginTop: 6 }}>
                      <ClarityMatrixGrid
                        data={CLARITY_ICI_ALL}
                        hover={this.state.hoverCell}
                        tooltip={this.state.tooltip}
                        onEnter={this.handleEnterCell}
                        onMove={this.handleMoveCell}
                        onLeave={this.handleLeaveCell}
                      />
                    </div>

                    <br></br><br></br>Please cite the following study if use the information in this website:
                    <br></br><br></br>
                    <txt style={{ fontStyle: 'italic' }}>
                     Clinical Attribute–Based Risk Matrix for Prognostication in Immunotherapy-Treated Non-Small-Cell Lung Cancer: An Individual-Patient Data Analysis of 17051 Patients.
                    </txt>
                    <br></br><br></br>

            
                  </txt>
                </div>
              </div>

            </Content>
          </Layout>
        </Content>
      </div>
    );
  }
}

export default ClarityICIWestern;
